import request from "@/utils/request";

// 接口的规则，用到什么写什么，比如只用到obj的id，就只写id
interface obj {
  roleId: string;
}
// 获取当前用户角色树
export const getCurrentUserRoleTreeList = () => {
  return request({
    url: `/baseRole/currUserRoleTreeList`,
    method: "get"
  });
};
// 通过id获取角色
export const getRolesById = (roleId: string) => {
  return request({
    url: `/baseRole/get/${roleId}`,
    method: "get"
  });
};
// 新增角色
export const postRoles = (obj: object) => {
  return request({
    url: `/baseRole`,
    method: "post",
    data: obj
  });
};
// 修改角色 通过id
export const putRolesById = (obj: obj) => {
  return request({
    url: `/baseRole/${obj.roleId}`,
    method: "put",
    data: obj
  });
};
// 删除角色 通过id
export const delRolesById = (roleId: string) => {
  return request({
    url: `/baseRole/${roleId}`,
    method: "delete"
  });
};
// export const updateLoginFlag= (data) => $request('post', '/gkzyfz/student/updateLoginFlag', data);

/*-------------------------- 用户角色页面的菜单方法-------------------------------- */
// 获取角色菜单树
export const getRoleMenuTreeList = (roleId: string) => {
  return request({
    url: `/baseRoleMenu/menuTreeList/${roleId}`,
    method: "get"
  });
};

//  增加角色菜单
export const putRoleMenu = (id: string, menuIds: Array<string>) => {
  return request({
    url: `/baseRoleMenu/${id}`,
    method: "put",
    data: menuIds
  });
};

// 根据角色id和菜单id获取角色菜单信息
export const getRoleMenu = (menuId: string, roleId: string) => {
  return request({
    url: `/baseRoleMenu/getRoleMenu/`,
    method: "get",
    params: {
      menuId, // 菜单id
      roleId // 角色id
    }
  });
};

// 根据角色id 和菜单id 修改角色菜单信息
export const updateRoleMenu = (data: object) => {
  return request({
    url: `/baseRoleMenu/updateRoleMenu/`,
    method: "post",
    data
  });
};
///baseRoleMenu/getRoleMenu/

// ------------------------ 角色资源操作---------------------------------//
// 获取角色资源分页列表 /baseRoleResource/getPage
export const getRoleResource = (data: object) => {
  // export const getRoleResource =()=>{
  return request({
    url: `/baseRoleResource/getPage`,
    method: "post",
    data
    // {
    //     "current": 1,
    //     "menuId": 1,
    //     "roleId": 1,
    //     "size": 15
    //   }
  });
};

// 批量绑定角色资源 /baseRoleResource/batchAdd/{roleId}
export const putBatchAdds = (roleId: string, resourceIds: Array<string>) => {
  return request({
    url: `/baseRoleResource/batchAdd/${roleId}`,
    method: "put",
    data: resourceIds
  });
};
// 批量解绑角色资源 /baseRoleResource/batchDel/{roleId}
export const delBatchDel = (roleId: string, resourceIds: Array<string>) => {
  return request({
    url: `/baseRoleResource/batchDel/${roleId}`,
    method: "delete",
    data: resourceIds
  });
};

// ***********tab栏右侧 基础角色用户操作***************
// /baseUserRole/getPage/{roleId} 获取角色用户分页列表
export const getBaseUserPage = (roleId: string, baseUserQueryForm: object) => {
  return request({
    url: `/baseUserRole/getPage/${roleId}`,
    method: "post",
    data: baseUserQueryForm
  });
};
// /baseUserRole/batchDel/{roleId} 批量解绑角色用户
export const delBaseUserRole = (roleId: string, userIds: Array<string>) => {
  return request({
    url: `/baseUserRole/batchDel/${roleId}`,
    method: "delete",
    data: userIds
  });
};
// /baseUserRole/batchAdd/{roleId} 批量绑定角色用户
export const putBaseUserRole = (roleId: string, userIds: Array<string>) => {
  return request({
    url: `/baseUserRole/batchAdd/${roleId}`,
    method: "put",
    data: userIds
  });
};
